import React from 'react';

import Input from 'components/shared/FormAdapters/FormDefault/Input';

import styles from './index.module.css';

const inputProps = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: 'false',
};

function ColorInput(props) {
  return (
    <Input
      {...props}
      startAdornment={<div className={styles.swatch} style={{ backgroundColor: props.value }} />}
      adornmentProps={{ width: 60 }}
      {...inputProps}
    />
  );
}

export default ColorInput;
